'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './stripeRedirect.routes.js';
import StripeRedirectCtrl from './stripeRedirect.controller.js';

export default angular.module('georgeApp.stripeRedirect', [uiRouter])
  .config(routing)
  .controller('StripeRedirectCtrl', StripeRedirectCtrl)
  .name;
